module.exports = __webpack_public_path__ + "img/checkbox-hovered.cbb6b52e035a2b538332d1641213080d.svg";